import type { LeadsInt32ItemsFilter } from '@app/api/Leads/types';
import type { MultiSelectValue } from '@app/shared/components/MultiSelect/types';

// Maps the tags MultiSelect value into the `SearchLeads` `TagFilters` request
// shape. Leads-local equivalent of the legacy registry mapping: each group
// becomes one filter; inner logic AND/OR/NOT maps to `InnerInclude`
// (true/false/null), and the group-to-group relation maps to `OuterInclude`.
export const mapTagsFilterToInt32ItemsFilters = (
  tags: MultiSelectValue | null | undefined
): LeadsInt32ItemsFilter[] | null => {
  if (!tags?.groups?.length) return null;

  const selectedGroups = tags.groups.filter(
    (group) => group.selectedValues.length > 0
  );

  if (selectedGroups.length === 0) return null;

  return selectedGroups.map((group, index): LeadsInt32ItemsFilter => {
    const innerInclude =
      group.logic === 'AND' ? true : group.logic === 'OR' ? false : null;

    const outerInclude =
      index === 0
        ? true
        : group.relationToPrev
        ? group.relationToPrev === 'AND'
        : true;

    const itemIds = group.selectedValues
      .map(Number)
      .filter((value) => Number.isFinite(value));

    return {
      OuterInclude: outerInclude,
      InnerInclude: innerInclude,
      ItemIds: itemIds.length ? itemIds : null,
    };
  });
};
